







































































import { Vue, Component, Prop } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Enums/Data
import { ImportFileScanStatus } from "@/data/enums/imports";

// Types
import { IFile } from "@/models/files";

@Component
export default class ImportFileListItem extends Vue {
  // Props

  @Prop({ default: false })
  public isLoading!: boolean;

  @Prop({ default: null })
  public file!: IFile;

  @Prop({ default: () => null })
  public selectedFileIds!: IFile["id"];

  @Prop({ default: true })
  public isClickable!: boolean;

  @Prop({ default: true })
  public showStatus!: boolean;

  // Methods

  public itemSelected(value) {
    this.$emit("selectFile", this.file, value);
  }

  // Computed

  public get showSkeletons() {
    return this.$_.isNull(this.file);
  }

  public get isSelectable() {
    return !_.isNull(this.selectedFileIds);
  }

  public get isSelected() {
    return (
      this.isSelectable &&
      _.some(
        this.selectedFileIds,
        selectedFileId => selectedFileId === this.file?.id
      )
    );
  }

  public get fileStatus() {
    switch (this.file.scan_status) {
      case ImportFileScanStatus.SCANNING:
        return {
          label: this.$t("_.scanning"),
          icon: "clock",
          type: "warning",
          tooltipLabel: this.$t("_sentence.imports.file_scanning_tooltip")
        };
      case ImportFileScanStatus.ERROR:
        return {
          label: this.$t("_.error"),
          icon: "exclamation-circle",
          type: "danger",
          tooltipLabel: this.$t("_sentence.imports.file_error_tooltip")
        };
      case ImportFileScanStatus.UNSAFE:
        return {
          label: this.$t("_.unsafe"),
          icon: "exclamation-circle",
          type: "danger",
          tooltipLabel: this.$t("_sentence.imports.file_unsafe_tooltip")
        };
      default:
        return {
          label: this.$t("_.safe"),
          icon: "check",
          type: "success",
          tooltipLabel: this.$t("_sentence.imports.file_safe_tooltip")
        };
    }
  }
}
